import { connect, Dispatch } from 'react-redux';

import { AppState } from '../../..';
import { CoveragePageProperties } from './coverage.reducer';
import { EmployeeDiscountViewModel, ProductViewModel } from '@models/Product';
import { StatesViewModel, OptionsViewModel } from '@models/common.models';
import { ContractViewModel } from '@models/Contract';
import { PriceAdjustmentsContainer } from './_components/price-adjustments.container';

export interface PriceAdjustmentStepProps {
  readonly isEmployeeDiscountEnabled: boolean;
  readonly next?: Function;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly saleTypeId: number;
  readonly propertyTypeId: number;
  readonly employeeDiscounts: Array<EmployeeDiscountViewModel>;
  readonly state: StatesViewModel;
  readonly hasPropertyManagement: boolean;
  readonly hasAgent: boolean;
  readonly currentStep?: number;
  readonly isOrderEdit?: boolean;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: PriceAdjustmentStepProps): Partial<CoveragePageProperties> {
  return {
    state: (((state.contract || {}).contractVM || ({} as ContractViewModel)).propertyAddress || {}).state,
    zipCode: (((state.contract || {}).contractVM || ({} as ContractViewModel)).propertyAddress || {}).zip,
    propertyTypeId: (
      ((state.contract || {}).contractVM || ({} as { propertyType: OptionsViewModel })).propertyType || {}
    ).id,
    hasPropertyManagement: state.contract.propertyManager !== undefined,
    hasAgent: ((state.contract || {}).contractVM || ({} as { initAgentId: number })).initAgentId !== undefined,
    saleTypeId: (((state.contract || {}).contractVM || ({} as ContractViewModel)).propertySaleType || {}).id,
    buttonRef: ownProps.buttonRef,
    buyerId: ((state.contract || {}).contractVM || ({} as ContractViewModel)).buyerId,
    productId: (((state.contract || {}).contractVM || ({} as { product: ProductViewModel })).product || {}).id,
    contractVM: (state.contract || {}).contractVM || ({} as ContractViewModel),
    currentStep: ownProps.currentStep
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: PriceAdjustmentStepProps
): Partial<PriceAdjustmentStepProps> {
  return {
    next: ownProps.next
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PriceAdjustmentsStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(PriceAdjustmentsContainer);



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/price-adjustments-step.container.tsx